export default {
  'menu.AnnouncementRecordDetailPage': '公告详情',

  // GENERATOR_KEEP_DO_NOT_DELETE_THIS_LINE
};
